import {ChangeDetectionStrategy, Component, ViewChild} from '@angular/core';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {BehaviorSubject} from "rxjs";
import {ErrorHandlingService} from "@app/services/misc-services/error-handling.service";
import {GlobalSpinnerService} from "@app/services/misc-services/global-spinner.service";
import {PortalUser} from "@app/model/portal-user.model";
import {AccountRequestComponent} from "@app/login/account-request/account-request.component";
import {ForgotPasswordComponent} from "@app/login/forgot-password/forgot-password.component";

@Component({
    selector: 'flex-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent {
    username: string = '';
    password: string = '';
    msg: BehaviorSubject<string> = new BehaviorSubject<string>( '');
    requestAccountDialogRef: MatDialogRef<AccountRequestComponent>;
    requestPasswordDialogRef: MatDialogRef<ForgotPasswordComponent>;

    constructor(
        public dialogRef: MatDialogRef<LoginComponent>,
        public dialog: MatDialog,
        private http: HttpClient,
        private errorService: ErrorHandlingService,
        private globalSpinner: GlobalSpinnerService) {
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    validateUser() {
        this.globalSpinner.addEvent('signin', 'Attempting SignIn');
        this.msg.next( '');
        this.http.post(`api/unsecured/signin`, {
            username: this.username?.toUpperCase(),
            password: this.password
        }).subscribe((signin: PortalUser) => {
            if (signin.username) {
                this.dialogRef.close(signin);
            } else {
                this.msg.next( 'Username or Password is incorrect.');
            }
            this.globalSpinner.removeEvent('signin')
        },
            (error: HttpErrorResponse) => {
                console.error(error)
                this.globalSpinner.removeEvent('signin');
                this.msg.next( 'Username or Password is incorrect.');

                this.errorService.handleError(`Username or Password is incorrect.`)
            });
    }

    requestAccount(){
        this.requestAccountDialogRef = this.dialog.open(AccountRequestComponent, {height: '500px', width: '800px'});
    }

    forgotPassword(){
        this.requestPasswordDialogRef = this.dialog.open(ForgotPasswordComponent, {width: '800px'});
    }
}
